import { Component, OnInit, ViewChild } from '@angular/core';
import { CommonModule, NgFor, NgIf } from '@angular/common';
import { HeaderComponent } from '../../components/header/header.component';
import { FooterComponent } from '../../components/footer/footer.component';
import {
  FormsModule,
  ReactiveFormsModule,
  FormBuilder,
  FormGroup,
  Validators,
} from '@angular/forms';
import { DatasearchService } from '../../_services/datasearch.service';
import { RecaptchaModule, RecaptchaComponent } from 'ng-recaptcha';
import { BusyService } from '../../_services/busy.service';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { Router } from '@angular/router';

@Component({
  selector: 'app-forgot-password',
  standalone: true,
  imports: [
    HeaderComponent,
    FooterComponent,
    FormsModule,
    ReactiveFormsModule,
    RecaptchaModule,
    CommonModule,
    NgIf,
    NgFor,
    ToastModule,
  ],
  providers: [MessageService],
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
})
export class ForgotPasswordComponent implements OnInit {
  @ViewChild('recaptchaRef') recaptchaRef!: RecaptchaComponent;
  forgotPasswordForm!: FormGroup;
  recaptchaResponse: string | null = null;
  formSubmitted = false;
  sentEmail: string = '';

  recaptchaSiteKey = '6LfvdWgqAAAAAB4irdmbPCmlpmyBzGLjGVIrHE_S'; // live
  // recaptchaSiteKey = '6Lcpo3QqAAAAAIKDJyb4lg4QKCWMuQMA7VxbP9uD'; // local

  constructor(
    private fb: FormBuilder,
    private datasearch: DatasearchService,
    private busyService: BusyService,
    private messageService: MessageService,
    private router: Router
  ) {}

  ngOnInit() {
    this.initForgotPasswordForm();
  }

  initForgotPasswordForm() {
    this.forgotPasswordForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
    });
  }

  submitforgetpasswordform() {
    if (this.forgotPasswordForm.valid && this.recaptchaResponse) {
      this.formSubmitted = true;
      const email = this.forgotPasswordForm.get('email')?.value;
      this.sentEmail = email;
      const formData = new FormData();
      formData.append('username', email);
      formData.append('web', 'Agro');
      this.busyService.busy();
      this.datasearch.sendForgotpswd(formData).subscribe(
        (response) => {
          this.busyService.idle();
          this.formSubmitted = false;
          if (response.status === 'success') {
            this.messageService.add({
              severity: 'success',
              summary: 'Check Email',
              detail: response.message,
              life: 10000,
            });
            this.resetCaptcha(100);
            this.forgotPasswordForm.reset();
            this.busyService.busy();
            setTimeout(() => {
              this.busyService.idle();
              this.router.navigate(['/home']);
            }, 2000);
          } else {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: response.message,
              life: 10000,
            });
            this.resetCaptcha(2000);
          }
        },
        (error) => {
          this.busyService.idle();
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'An error occurred while sending the request.',
            life: 10000,
          });
        }
      );
    } else {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'All fields are required',
        life: 10000,
      });
      this.resetCaptcha(2000);
    }
  }

  onCaptchaSuccess(token: string | null) {
    this.recaptchaResponse = token;
    this.resetCaptcha(60000);
  }

  resetCaptcha(time: number) {
    setTimeout(() => {
      this.recaptchaResponse = null;
      this.recaptchaRef.reset();
    }, time);
  }
}
